import React from 'react';

import { propTypes, withFormsy } from 'formsy-react';
import { Switch } from 'twyne-new.ui'

export function PureSwitch({ value, disabled, id, onChange, ...props }) {
  return <Switch id={id} value={value ? value : false} disabled={disabled} onChange={onChange} {...props} />
}

function Checkbox({ disabled, getValue, setValue, name, id, onChange }) {
  return <PureSwitch
    id={id || name}
    disabled={disabled}
    onChange={evt => {
      setValue(evt.target.checked)
      onChange && onChange(evt.target.checked)
    }}
    value={getValue()}
  />
}

Checkbox.propTypes = {
  ...propTypes,
};

export default withFormsy(Checkbox);
